module.exports = __webpack_public_path__ + "static/media/HardlopenvoorBedrijven-13.df415ffd.jpg";